@if (data(); as msg) {
    Updated <project-item [project]="msg.project" />
}
 